"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurationBackupRestorePointTypeCellRenderer = void 0;
const constants_1 = require("../../../../constants");
const core_1 = require("../../../../core");
const configurationBackupRestorePointTypeCellRenderer = ({ texts }) => (data) => {
    switch (data.type) {
        case core_1.CONFIGURATION_BACKUP_RESTORE_POINT_TYPE.manual:
            return texts.manual;
        case core_1.CONFIGURATION_BACKUP_RESTORE_POINT_TYPE.schedule:
            return texts.schedule;
        case core_1.CONFIGURATION_BACKUP_RESTORE_POINT_TYPE.none:
        default:
            return constants_1.EMPTY_TEXT.dash;
    }
};
exports.configurationBackupRestorePointTypeCellRenderer = configurationBackupRestorePointTypeCellRenderer;
//# sourceMappingURL=configurationBackupRestorePointTypeCellRenderer.js.map